import { api } from '../../client';

export interface InventoryStatsDto {
  total_products: number;
  low_stock: number;
  out_of_stock: number;
  stock_value: number;
}

export interface ProductDto {
  id: string;
  sku: string;
  product_name: string;
  category: string;
  product_type: string;
  unit_of_measure: string;
  description: string;
  cost_price: number;
  selling_price: number;
  tax_rate: number;
  qty_on_hand: number;
  reorder_level: number;
  reorder_qty: number;
  status: string;
  is_low_stock: boolean;
  is_out_of_stock: boolean;
  created_at?: string;
  updated_at?: string;
}

export const inventoryProductsApi = {
  async list(
    search?: string
  ): Promise<{
    data?: ProductDto[];
    stats?: InventoryStatsDto;
    message?: string;
    errors?: Record<string, string[]>;
  }> {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/inventory/products${q}`) as Promise<{
      data: ProductDto[];
      stats: InventoryStatsDto;
    }>;
  },

  async get(id: string): Promise<{ data?: ProductDto; message?: string }> {
    return api.get(`/inventory/products/${id}`) as Promise<{ data: ProductDto }>;
  },

  async create(data: {
    sku: string;
    product_name: string;
    category?: string;
    product_type?: string;
    unit_of_measure?: string;
    description?: string;
    cost_price?: number;
    selling_price?: number;
    tax_rate?: number;
    qty_on_hand?: number;
    reorder_level?: number;
    reorder_qty?: number;
    status?: string;
  }): Promise<{ data?: ProductDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/inventory/products', data) as Promise<{
      data: ProductDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: {
      sku?: string;
      product_name?: string;
      category?: string;
      product_type?: string;
      unit_of_measure?: string;
      description?: string;
      cost_price?: number;
      selling_price?: number;
      tax_rate?: number;
      qty_on_hand?: number;
      reorder_level?: number;
      reorder_qty?: number;
      status?: string;
    }
  ): Promise<{ data?: ProductDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/inventory/products/${id}`, data) as Promise<{
      data: ProductDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/inventory/products/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
